module.exports = __webpack_public_path__ + "img/maoer.9ddc8ed8.png";